

export {
    type TiEntities,
    //TiRouteSlotsReview,
    type TiInterfaces,
    TiClassNames
}

enum TiClassNames {
    "section_main_route_timeslot" = "section_main_route_timeslot",
    "transport_route" = "transport_route",
    "stage" = "stage",
    "booking_entity_resource" = "booking_entity_resource",
    "logistics_resource_timeslot" = "logistics_resource_timeslot",
    "vt_logistics_resource" = "vt_logistics_resource",
    "vt_timeslot" = "vt_timeslot",
    "timetable_timeslot" = "timetable_timeslot",
    "vt_timetable" = "vt_timetable",
    "trailer" = "trailer"
}
namespace TiInterfaces {
    export interface TiTransportRouteViewConfig {
        
    }

    export interface CustomMainRouteData {
        mainRouteID: string;
        sections: Array<SimpleSectionData>
    }


    export interface SimpleSectionData {
        sectionID: string;
        sectionSlotID: string;
        sorting: number;
    }

    export interface DummyPropertyExtension {
        _isDummy?: boolean
        _placeholderLabel?: string
    }

    export interface TiStageConfig {
        
    }

    export interface TiRouteSectionsViewConfg {
        enableBookingStatus?: boolean | "interactive",
        highlight?: boolean,
        showExtendedInformation?: boolean
    }
    export interface TiTransportGoodManagerConfig {
        showFreightOccupation?: boolean
        interactive?: boolean
    }

    export interface TiMainRouteViewConfig {
        highlightSectionSlotID?: string,
        highlightMode?: "fadeAfterTarget" | "fadeBeforeTarget"
        sectionsConfig: TiRouteSectionsViewConfg
    }

    export interface TiBookingViewSettings {
        showSummary?: boolean | "expand" | "noExpander",
        showTransportGoods?: boolean | "expand" | "noExpander",
        showMainRoute?: boolean | "expand" | "noExpander",
        showTransportRoute?: boolean | "expand" | "noExpander",
        showBookingFormConfirmation?: boolean
        mainRouteViewConfig?: TiMainRouteViewConfig
        transportGoodsConfig?: TiTransportGoodManagerConfig
    }

    export interface BookingFormData {
        ID: string,
        logisticResourceID: string,
        mainRouteID: string,
        divisionID: string,
        terminalID: string,
        dateStart?: string,
        dateEnd?: string,
        routeSlotID: string,
        offloadingValue: number,
        orderNo: string,
        transportGoodID?: string,
        additionalTransportGoods?: Array<string>,
        is_cancelled?: boolean,
        mode: "book" | "rebook" | "reserve" | "cancel",
    }

    export interface BookingFormData_CustomRoute {
        customMainRouteData: TiInterfaces.CustomMainRouteData
    }

    export interface BookingRevisionFormData {
        bookingID: string,
        oldRouteSectionSlotID: string,
        divisionID: string,
        slotStatusID: string,
        newRouteSectionSlotID: string,
        cancelOldSlots: boolean
    }

    export interface TiTruck {
        ID: string;
        identification: string;
        is_dummy: boolean;
    }

    export interface RouteResource {
        ID: string;
        slotID: string;
        displayname: string;
        tooltip: string;
        summary: string;
        duration: number;
        name: string;
        note_multilingual: string;
        enableBooking: boolean;
        bookingNote: string;
    }
}

namespace TiEntities {

    export interface BookingListEntity {
        ID: string;
        booking_date: Date;
        actual_date: Date;
        target_date: Date;
        displayname: string;
        tmp_status_webdisplay: string;
        tmp_date_end_webdisplay: string;
        tmp_date_start_webdisplay: string;
        is_cancelled: boolean;
        is_rebook: boolean;
        order_number: string;
        tmp_order_numbers?: string;
        booking_entity_resource_type: number;
        is_contains_canceld_section_timeslot: boolean;
        is_canceld_section_timeslot_corrected: boolean;
        is_contains_reserved_section_timeslot: boolean;
        is_target_time_warning: boolean;
        ref_employee: {
            displayname: string;
            displayname2: string;
        }
        tmp_section_main_route_timeslot_1?: SectionTimeSlotEntity;
        tmp_section_main_route_timeslot_2?: SectionTimeSlotEntity;
        tmp_section_main_route_timeslot_3?: SectionTimeSlotEntity;
        ref_vt_timeslot: {
            ref_main_route: {
                name: string;
            }
        }
        ref_logistics_resource_timeslot: {
            ref_vt_logistics_resource: {
                ILU_Code: string;
                LDM?: number;
            }
            ref_start_terminal: Terminal
        }
        ref_logistics_resource_timeslot_new: {
            ref_start_terminal: Terminal
        }
    }
    export interface TimeslotEntity extends more.EntityAPIResult {
        date_start: Date;
        date_end: Date;
        ref_division: DivisionEntity;
        ref_original_divison: DivisionEntity;
        is_reassigned_division: boolean;
        ref_status_timeslot: TimeSlotStatus;
        ref_booking_status_timeslot: TimeSlotStatus;
        booked_on: Date;
        ref_booking_status_changed: {
            ID: string;
            name_address: string;
        }
        pickup_date: Date;
        buffer_time: Number;
    }
    export interface SectionTimeSlotEntity extends TimeslotEntity {
        ref_section_main_route: {
            ref_section: RouteSectionEntity
        }
        BookingNumber: string;
        BookingStatus: string;
    }
    export interface TimeTableSlotEntity extends TimeslotEntity {
        sectionSlots: Array<SectionTimeSlotEntity>;
    }
    

    export interface AddressBaseEntity extends more.EntityAPIResult
    {
        name_address: string
        displayname: string;
        coloration?: more.EntityAPIColor;
        note_multilingual: string;
        is_active?: boolean;
    }
    export interface EmployeeEntity extends AddressBaseEntity
    {
        //ref_division: DivisionEntity;
        EL_contact_person_division_vt_contact_person?: Array<DivisionAssignment>;
    }
    interface DivisionAssignment extends more.EntityAPIResult {
        is_active: boolean;
        ref_division: DivisionEntity;
        ref_vt_contact_person: EmployeeEntity; // nicht ganz korrekt, aber einfacher - Kontaktperson hamma grad nicht
    }
    export interface DivisionEntity extends AddressBaseEntity
    {
        
    }

    interface Country {
        name: string;
        identification: string;
        name_ptv: string;
    }

    export interface TransportGoodEntityBase extends more.EntityAPIResult {
        ref_country: Country;
        ref_country_2: Country;
        loading_time_start: Date;
        loading_time_end: Date;
        unloading_time_start: Date;
        unloading_time_end: Date;
        order_number: string;
        LDM: number;
        ref_status_good: _StatusBase & {
            is_revision_status: boolean;
        }

    }
    export interface TransportGoodEntity extends TransportGoodEntityBase {
        ref_dispatcher: AddressBaseEntity;
        ref_division: DivisionEntity;
        ref_customer: AddressBaseEntity;
        c_address_loading: string;
        c_address_unloading: string;
        c_zip_code: string;
        c_city: string;
        c_zip_code_2: string;
        c_city_2: string;
        weight: number;
        tmp_displayname_web: string;
        tmp_displayname_location_loading: string;
        tmp_displayname_location_unloading: string;
        ref_good_category: {
            displayname: string;
            coloration: more.EntityAPIColor;
        }
        date_end_target: Date;
        date_end: Date;
        quantity_of_pallets: number;
        ref_transport_route: TransportRouteEntity;
    }
    export interface RouteSectionEntity extends RouteEntity {
        ref_start_terminal: Terminal;
        ref_end_terminal: Terminal;
    }

    interface TransportType extends more.EntityAPIResult {
        name: string;
        sorting: number;
        coloration: more.EntityAPIColor;
        web_icon_class: string;
    }

    interface _StatusBase extends more.EntityAPIResult {
        coloration: more.EntityAPIColor;
        name: string;
        sorting: number;
    }
    interface TimeSlotStatus extends _StatusBase {
        
    }

    interface StageStatus extends _StatusBase {
        is_locked: boolean;
        is_revision_status: boolean;
        is_locked_logistics_resource_assignment: boolean;
    }
    export interface TimeSlotBookingStatus extends _StatusBase {

    }

    export interface TimeSlotEntity_Aliased {
        ID: string;
        Classname: string;
        name: string;
        date_start: Date;
        date_end: Date;
        is_full_time: boolean;
        buffer_time: number;
        pickup_date: Date;
        divisionID: string;
        originalDivisionID: string;
        isReassignedDivision: boolean;
        statusOrder: number;
        statusName: string;
        statusID: string;
        is_cancelled: boolean;
        bookingStatusName: string;
        bookingStatusID: string;
        bookingStatusColor: more.EntityAPIColor;
        bookingStatusOrder: number;
        bookingStatusChangeDate: Date;
        bookingStatusChangeAddress: string;
        bookingID: string;
    }

    // Section-Timeslot - daher auch bezug zur Mainroute-ID
    export interface SectionTimeSlotEntity_Aliased extends TimeSlotEntity_Aliased {
        sectionName: string;
        sectionID: string;
        sectionSlotAssignmentName: string;
        sectionSlotAssignmentID: string;
        mainRouteName: string;
        mainRouteID: string;
        mainRouteSlotName: string;
        mainRouteSlotID: string;
        timeTableSlotID: string;
        transportTypeName: string;
        transportTypeID: string;
        transportTypeOrder: string;
        transportTypeIcon: string;
        transportTypeColor: more.EntityAPIColor;
        bookingNumber: string;
        bookingStatus: string;
        routeProviderID: string;
        routeProviderDisplayname: string;
    }

    export interface MainRoute_Minimal extends more.EntityAPIResult {
        name: string;
    }
    export interface MainRoute extends MainRoute_Minimal, RouteEntity {
        ref_division: DivisionEntity;
        //EL_main_route_master_route_main_route: Array<any>;
        EL_section_main_route_main_route: Array<{ ref_section: RouteSectionEntity, sorting: number }>
    }

    // Mainroute-Timeslot

    export interface Terminal extends more.EntityAPIColor {
        name_address: string;
        displayname: string;
        displayname2: string;
        is_active: boolean;

    }

     export interface MainRouteTimeSlotEntity_Aliased extends TimeSlotEntity_Aliased {
        mainRouteName: string;
        mainRouteID: string;
        sectionSlotAssignments: Array<SectionTimeSlotAssignmentEntity_Aliased>;
    }

    // Verkn�pfung zwischen Mainroute und Section
    export interface SectionTimeSlotAssignmentEntity_Aliased extends TimeSlotEntity_Aliased {
        sectionSlot: SectionTimeSlotEntity_Aliased;
        mainRouteSlot: MainRouteTimeSlotEntity_Aliased;
    }


    export interface LogisticResource {
        ID: string;
        slotID: string;
        chassis_number: string;
        identification: string;
        displayname: string;
        LDM?: number;
        ref_start_terminal: Terminal
        ref_design_type_logistics_resource: {
            name: string
        }
        tooltip: string;
        summary: string;
    }

  
    export interface BookingEntityData extends TiInterfaces.BookingFormData {
        displayname?: string,
        division: string,
        terminal: string,
        route: string,
        offloading: string,
        logisticResourceTXT: string,
        logisticResource: TiEntities.LogisticResource,
        logisticResourceLDM: number,
        mainRouteCode?: string;
        status?: string
        is_contains_reserved_section_timeslot?: boolean;
        is_rebooking_available?: boolean,
        bookingType?: number;
        warnings?: Array<string>,
        bookingDate?: string,
        bookerName?: string,
        bookerID?: string
        dateStart?: string;
        dateEnd?: string;
        transportGood: TiEntities.TransportGoodEntity;
        transportGoods: Array<TiEntities.TransportGoodEntity>;
        routeSectionSlots?: Array<SectionTimeSlotEntity_Aliased>;
        oldMainRouteSlot?: MainRouteTimeSlotEntity_Aliased;
        newMainRouteSlot?: MainRouteTimeSlotEntity_Aliased;
        unloadingTerminalID?: string;
    }

    interface StageType extends more.EntityAPIResult {
        name: string;
        is_lock_logistics_resource: boolean;
        is_lock_logistics_resource_cargo_hold: boolean;
        sorting: number;
        coloration: more.EntityAPIColor;
    }
    interface RouteEntity extends more.EntityAPIResult {
        name: string;
        code: string;
        ref_transport_type: TransportType;

        ref_dispatcher: EmployeeEntity;
        displayname: string;
        autonumber: string;
        date_start_planned: Date;
        date_start_target: Date;
        date_start: Date;
        date_end: Date;
        date_end_planned: Date;
        date_end_target: Date;
        latitude: string;
        longitude: string;
        latitude_2: string;
        longitude_2: string;
        distance: number;
        traveltime: number;
        trafficdelay: number;
        c_address_loading: string;
        c_address_unloading: string;
        c_zip_code: string;
        c_zip_code_2: string;
        c_city: string;
        c_city_2: string;
        ref_country: Country;
        ref_country_2: Country;
        tmp_displayname_web: string;
        tmp_displayname_location_loading: string;
        tmp_displayname_location_unloading: string;
    }
    export interface TransportRouteEntity extends RouteEntity {
        EL_vt_route_transport_route: Array<StageEntity>

    }
    export interface StageEntity extends RouteEntity {
        EL_stage_base_stage: Array<StageEntity>
        ref_vt_logistics_resource: LogisticResource;
        ref_stage_type: StageType;
        ref_transport_type: TransportType;
        ref_status_stage: StageStatus;
        ref_vt_good: TransportGoodEntityBase;
    }


  

    
}

